const listValuations = async () => {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", localStorage.getItem("token"));
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/list_valuations`,
    requestOptions
  )
    .then((result) => {
      return result.json();
    })
    .catch((error) => {throw new Error(error)});
};

export default listValuations;
